export interface IUpdateLiftReport {
  id: string;
  enabled?: boolean;
  mainGoal?: boolean;
  activityPeriodFrom?: string;
  activityPeriodTo?: string;
}

class UpdateLiftReport {
  public readonly id: string;
  public readonly enabled?: boolean;
  public readonly mainGoal?: boolean;
  public readonly activityPeriodFrom?: string;
  public readonly activityPeriodTo?: string;

  constructor({
    id,
    enabled,
    mainGoal,
    activityPeriodFrom,
    activityPeriodTo,
  }: {
    id: string;
    enabled?: boolean;
    mainGoal?: boolean;
    activityPeriodFrom?: string;
    activityPeriodTo?: string;
  }) {
    this.id = id;
    this.enabled = enabled;
    this.mainGoal = mainGoal;
    this.activityPeriodFrom = activityPeriodFrom;
    this.activityPeriodTo = activityPeriodTo;
  }

  public toJSON = () => ({
    id: this.id,
    enabled: this.enabled,
    mainGoal: this.mainGoal,
    activityPeriodFrom: this.activityPeriodFrom,
    activityPeriodTo: this.activityPeriodTo,
  });

  public static fromJSON = (json: IUpdateLiftReport): UpdateLiftReport => {
    const { id, enabled, mainGoal, activityPeriodFrom, activityPeriodTo } = Object.assign({}, json);

    if (typeof id !== 'string') throw new Error('.id must be a string');
    if (typeof enabled !== 'boolean' && enabled !== undefined) throw new Error('.enabled must be a boolean');
    if (typeof mainGoal !== 'boolean' && mainGoal !== undefined) throw new Error('.mainGoal must be a boolean');
    if (typeof activityPeriodFrom !== 'string' && activityPeriodFrom !== undefined)
      throw new Error('.activityPeriodFrom must be a string');
    if (typeof activityPeriodTo !== 'string' && activityPeriodTo !== undefined)
      throw new Error('.activityPeriodTo must be a string');

    return new UpdateLiftReport({
      id,
      enabled,
      mainGoal,
      activityPeriodFrom,
      activityPeriodTo,
    });
  };
}

export default UpdateLiftReport;
